const gradeArr = [{id: 1, name: '一年级'}, {id: 2, name: '二年级'}, {id: 3, name: '三年级'}, {id: 4, name: '四年级'}, {id: 5, name: '五年级'}, {id: 6, name: '六年级'}, {id: 7, name: '初一年级'}, {id: 8, name: '初二年级'}, {id: 9, name: '初三年级'}, {id: 10, name: '高一年级'}, {id: 11, name: '高二年级'}, {id: 12, name: '高三年级'}, {id: 13, name: '大学一年级'}, {id: 14, name: '大学二年级'}, {id: 15, name: '大学三年级'}, {id: 16, name: '大学四年级'}]

export default (info) => {
  if (info) {
    let list = gradeArr.filter(item => item.id === info)
    return list[0] ? list[0].name : '未知'
  }
}
